// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IBeneficiaryUpdateDto
 */
export interface IBeneficiaryUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof IBeneficiaryUpdateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IBeneficiaryUpdateDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof IBeneficiaryUpdateDto
     */
    beneficiary_type: IBeneficiaryUpdateDtoBeneficiaryTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof IBeneficiaryUpdateDto
     */
    birth_on?: Date;
    /**
     * 
     * @type {string}
     * @memberof IBeneficiaryUpdateDto
     */
    ssn?: string;
    /**
     * 
     * @type {string}
     * @memberof IBeneficiaryUpdateDto
     */
    tax_id?: string;
    /**
     * 
     * @type {string}
     * @memberof IBeneficiaryUpdateDto
     */
    relationship_type: IBeneficiaryUpdateDtoRelationshipTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IBeneficiaryUpdateDto
     */
    line1: string;
    /**
     * 
     * @type {string}
     * @memberof IBeneficiaryUpdateDto
     */
    line2?: string;
    /**
     * 
     * @type {string}
     * @memberof IBeneficiaryUpdateDto
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof IBeneficiaryUpdateDto
     */
    state: string;
    /**
     * 
     * @type {string}
     * @memberof IBeneficiaryUpdateDto
     */
    zipcode: string;
    /**
     * 
     * @type {number}
     * @memberof IBeneficiaryUpdateDto
     */
    allocation_percentage: number;
}

/**
* @export
* @enum {string}
*/
export enum IBeneficiaryUpdateDtoBeneficiaryTypeEnum {
    PRIMARY = 'PRIMARY',
    CONTINGENT = 'CONTINGENT'
}
/**
* @export
* @enum {string}
*/
export enum IBeneficiaryUpdateDtoRelationshipTypeEnum {
    SPOUSE = 'SPOUSE',
    PARTNER = 'PARTNER',
    CHILD = 'CHILD',
    PARENT = 'PARENT',
    DEPENDENT = 'DEPENDENT',
    GUARDIAN = 'GUARDIAN',
    TRUST = 'TRUST',
    ESTATE = 'ESTATE',
    OTHER = 'OTHER'
}


/**
 * Check if a given object implements the IBeneficiaryUpdateDto interface.
 */
export function instanceOfIBeneficiaryUpdateDto(value: object): value is IBeneficiaryUpdateDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('beneficiary_type' in value) || value['beneficiary_type'] === undefined) return false;
    if (!('relationship_type' in value) || value['relationship_type'] === undefined) return false;
    if (!('line1' in value) || value['line1'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('state' in value) || value['state'] === undefined) return false;
    if (!('zipcode' in value) || value['zipcode'] === undefined) return false;
    if (!('allocation_percentage' in value) || value['allocation_percentage'] === undefined) return false;
    return true;
}

export function IBeneficiaryUpdateDtoFromJSON(json: any): IBeneficiaryUpdateDto {
    return IBeneficiaryUpdateDtoFromJSONTyped(json, false);
}

export function IBeneficiaryUpdateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IBeneficiaryUpdateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'],
        'beneficiary_type': json['beneficiary_type'],
        'birth_on': json['birth_on'] == null ? undefined : (new Date(json['birth_on'])),
        'ssn': json['ssn'] == null ? undefined : json['ssn'],
        'tax_id': json['tax_id'] == null ? undefined : json['tax_id'],
        'relationship_type': json['relationship_type'],
        'line1': json['line1'],
        'line2': json['line2'] == null ? undefined : json['line2'],
        'city': json['city'],
        'state': json['state'],
        'zipcode': json['zipcode'],
        'allocation_percentage': json['allocation_percentage'],
    };
}

export function IBeneficiaryUpdateDtoToJSON(json: any): IBeneficiaryUpdateDto {
    return IBeneficiaryUpdateDtoToJSONTyped(json, false);
}

export function IBeneficiaryUpdateDtoToJSONTyped(value?: IBeneficiaryUpdateDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'beneficiary_type': value['beneficiary_type'],
        'birth_on': value['birth_on'] == null ? undefined : ((value['birth_on']).toISOString().substring(0,10)),
        'ssn': value['ssn'],
        'tax_id': value['tax_id'],
        'relationship_type': value['relationship_type'],
        'line1': value['line1'],
        'line2': value['line2'],
        'city': value['city'],
        'state': value['state'],
        'zipcode': value['zipcode'],
        'allocation_percentage': value['allocation_percentage'],
    };
}

